<template>
    <div class="product-marketing">
        <!--
        
        -->
      <section data-v-5a90ec03 class="py-4 mobile-top" style="background-image: url('/img/fortheaderbg.jpg'); background-size: cover; background-position: center; background-repeat: no-repeat; min-height: 200px;">
        <div class="container">
          <div data-v-5a90ec03 class="row">
            <div
              class="col-12 col-sm-12 col-md-10 offset-md-1 col-xs-8 col-sm-8 col-lg-8 offset-lg-2"
              style="text-align: center; padding: 15px 0;"
            >
            <img src="/img/fort-logo.png" />
            <br/>
                <h1 v-if="loading && !content" class="text-white" style="margin-top: 10px; border: 4px solid #00B4B4; border-radius: 50px; display: inline-block; padding: 5px 20px; font-weight: bold; font-size: 20px;">Loading</h1>
                <h1 v-else class="text-white" style="margin-top: 10px; border: 4px solid #00B4B4; border-radius: 50px; display: inline-block; padding: 5px 20px; font-weight: bold; font-size: 20px;">{{ content.title }}</h1>
            </div>
          </div>
        </div>
      </section>

      <div
                v-if="loading && !content"
                class="col-xs-12 col-sm-12 col-12 col-lg-12"
              >
                <div class="flex-box-wrap" style="margin: 150px 0!important;">
                  <div class="flex-internal">
                    <atom-spinner
                      :animation-duration="1000"
                      :size="40"
                      :color="'#575757'"
                    />
                    <p>Loading......</p>
                  </div>
                </div>
      </div>
  
      <div v-else class="container">
        <div class="row">
  
           <div class="col-xs-12 col-sm-12 col-12 col-lg-12">
      
  
  
          <div id="newFort">
         
            <fort-builder :blocks="content.blocks" :loading="loading"/>
         
            
            <!--
            <intro-letter />
            <divider />
            <score-card />
            <divider />
            <deliver-win/>
            <divider />
            <above-par />
            <divider />
            <vm-update />
            <divider />
            <news-to-know />
            <divider />
            <save-the-date />
            -->
            
          </div>
          <!-- end other column -->
        </div>
        </div>
      </div>
      <!-- container -->
    </div>
  </template>
  
  <script>
  import axios from "axios";
  import { AtomSpinner } from "epic-spinners";
  import NothingFound from '@/components/feedback/NothingFound.vue';
  import BackButton from '@/components/Buttons/BackButton.vue';
  import Loading from '@/components/feedback/Loading.vue';
  import IntroLetter from "@/components/FortBuilder/IntroLetter.vue";
  import ScoreCard from "@/components/FortBuilder/ScoreCard.vue";
import DeliverWin from '../components/FortBuilder/DeliverWin.vue';
import AbovePar from "@/components/FortBuilder/AbovePar.vue";
import Divider from "@/components/FortBuilder/Divider.vue";
import VmUpdate from "@/components/FortBuilder/VmUpdate.vue"
import NewsToKnow from "@/components/FortBuilder/NewsToKnow.vue";
import SaveTheDate from "@/components/FortBuilder/SaveTheDate.vue";
import FortBuilder from "@/components/FortBuilder/FortBuilder.vue";






  // import Avatar from "vue3-avatar";
  
  //http://mktginfo.spacesaver.com/wp-json/wp/v2/posts
  //http://mktginfo.spacesaver.com/wp-json/wp/v2/posts?slug=post-slug
  
  const auth = {
    headers: {
      Authorization: "Bearer spacesaver/ab3f641f910eb693804bc5b097a5bda6",
    },
  };

  const apiClient = axios.create({
  baseURL: 'https://news.spacesaver.com', 
  headers: {
    'Content-Type': 'application/json',
    // Add Authorization header if needed
    // Authorization: `Bearer ${yourToken}`,
  },
  withCredentials: true, // Include cookies if credentials: true in CORS config
});


  
  export default {
    name: "FortNewSingle",
    components: {
        AtomSpinner,
        NothingFound,
        BackButton,
        Loading,
        IntroLetter,
        ScoreCard,
        DeliverWin,
        AbovePar,
        AbovePar,
        Divider,
        VmUpdate,
        NewsToKnow,
        SaveTheDate,
        SaveTheDate,
        FortBuilder,
    },
    data() {
      return {
        trailblazor: import.meta.env.VITE_APP_TRAILBLAZOR,
        posts: [],
        pageSlug: "",
        loading: true,
        content: null,
        pageSlug: "",
      };
    },
    methods: {
      firstLoad: function () {
        const preview = new URLSearchParams(window.location.search).get('preview') === 'true';
        this.pageSlug = this.$route.params.slug;
        this.loading = true;

        if(preview){
          console.log(preview)
          return apiClient
            .get(`https://news.spacesaver.com/api/from-the-forts?filters[slug][$eq]=${this.pageSlug}&status=draft&populate=*`)
            .then((response) => {
              console.log(response.data.data[0]);
              this.content = response.data.data[0];
              this.loading = false;
            })
            .catch((error) => {
              console.error('Error loading content:', error);
              if (error.response && error.response.status === 401) {
                // this.$toast.error("Your session has timed out. Please sign in to continue.", { hideProgressBar: false, icon: false });
                this.$router.push('/');
              }
            });
        } else {
          return apiClient
            .get(`https://news.spacesaver.com/api/from-the-forts?filters[slug][$eq]=${this.pageSlug}&populate=*`)
            .then((response) => {
              console.log(response.data.data[0]);
              this.content = response.data.data[0];
              this.loading = false;
            })
            .catch((error) => {
              console.error('Error loading content:', error);
              if (error.response && error.response.status === 401) {
                // this.$toast.error("Your session has timed out. Please sign in to continue.", { hideProgressBar: false, icon: false });
                this.$router.push('/');
              }
            });
          }
      },
    
      goBack() {
        // Navigate back in the browser's history
        this.$router.go(-1);
      }
    },
    computed: {
      activeNav() {
        return this.$store.state.activePage;
      },
      pageStart: function () {
        return (this.currPage - 1) * this.countOfPage;
      },
      totalPage: function () {
        return Math.ceil(this.posts.length / this.countOfPage);
      },
    },
    created() {
      this.$store.commit("showNavigation");
      /*
      document
        .getElementById("mobileScrollTarget")
        .scrollIntoView({ behavior: "smooth" });
        */
      this.firstLoad();
      //console.log(this.$route.params.slug);
      // console.log(this.$route.path);
    },
    mounted() {},
  };
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
  .post {
    background: #fff;
    padding: 20px;
    margin-bottom: 20px;
    height: 100%;
  }
  .post-excerpt {
    font-size: 14px;
  }
  .post button {
    position: absolute;
    bottom: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    background: #00b4b4;
    color: #fff;
    border-radius: 4px;
  }
  
  .flex-box-wrap {
    margin-top: 200px;
  }
  .post-title {
    font-size: 2.5em;
  }
  
  body {
      background: #efefef;
      color: #575757;
      font-family: Poppins,sans-serif;
      font-family: Ubuntu,sans-serif;
      background-color: #f1f6f9!important;
      background: #f7fafc
  }
  #newFort{
    margin: 20px 0;
    padding: 20px 0px;
  }
  @media (max-width: 1199px) {
    #newFort {
        margin: 20px 0;
        padding: 20px 50px; /* Reduce horizontal padding */
    }
}
  /* Tablets (screens up to 768px) */
@media (max-width: 991px) {
    #newFort {
        margin: 20px 0;
        padding: 20px 0; /* Reduce horizontal padding */
    }
}

/* Mobile devices (screens up to 480px) */
/*
@media (max-width: 480px) {
    #newFort {

    }
}
*/
  </style>
  <style>
 .fort-body a{
    color: #00b4b4;
    font-family: "Figtree", sans-serif !important;
}

 .fort-body p {
    font-size: 16px;  
    font-family: "Figtree", sans-serif !important;
}
.fort-body h1 {
    font-size: 44px;  
    font-weight: bold;
    font-family: "Figtree", sans-serif !important;
}
.fort-body h2 {
    font-size: 40px;  
    font-weight: bold;
    font-family: "Figtree", sans-serif !important;
}
.fort-body h3 {
    font-size: 32px; 
    font-weight: bold; 
    font-family: "Figtree", sans-serif !important;
}
.fort-body h4 {
    font-size: 24px;  
    font-weight: bold;
    font-family: "Figtree", sans-serif !important;
}
.fort-body h5 {
    font-size: 22px; 
    font-weight: bold; 
    font-family: "Figtree", sans-serif !important;
}
.fort-body h6 {
    font-size: 18px; 
    font-weight: bold; 
    font-family: "Figtree", sans-serif !important;
}
  </style>

  